<template>
  <div
    v-if="open"
    class="captcha-modal-backdrop"
    data-testid="captcha-modal"
    @mousedown.self="requestClose"
  >
    <div
      ref="dialog"
      class="captcha-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="captcha-modal-title"
      tabindex="-1"
      @keydown.esc.stop.prevent="requestClose"
      @keydown.tab="trapFocus"
    >
      <div class="captcha-modal-header">
        <h2 id="captcha-modal-title" class="captcha-modal-title">
          Security check
        </h2>
        <button
          type="button"
          class="captcha-modal-close"
          aria-label="Close the security check"
          @click="requestClose"
        >
          &times;
        </button>
      </div>

      <CaptchaChallenge
        :show-label="false"
        labelled-by="captcha-modal-title"
        @verified="$emit('verified')"
        @unverified="$emit('unverified')"
      />
    </div>
  </div>
</template>

<script>
import CaptchaChallenge from "./CaptchaChallenge.vue";

const FOCUSABLE =
  'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])';

export default {
  name: "CaptchaModal",
  components: { CaptchaChallenge },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["verified", "unverified", "close"],
  data() {
    return {
      previouslyFocused: null,
    };
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        this.previouslyFocused = document.activeElement;
        document.body.style.overflow = "hidden";
        this.$nextTick(() => this.$refs.dialog?.focus());
      } else {
        document.body.style.overflow = "";
        this.previouslyFocused?.focus?.();
        this.previouslyFocused = null;
      }
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  methods: {
    requestClose() {
      this.$emit("close");
    },

    trapFocus(event) {
      const focusable = Array.from(
        this.$refs.dialog?.querySelectorAll(FOCUSABLE) || []
      ).filter((el) => !el.disabled && el.offsetParent !== null);

      if (!focusable.length) {
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && (active === first || active === this.$refs.dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    },
  },
};
</script>

<style scoped>
.captcha-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  z-index: 1000;
}

.captcha-modal {
  background: #ffffff;
  border-radius: 8px;
  padding: 20px 25px 25px 25px;
  width: 100%;
  max-width: 420px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.captcha-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.captcha-modal-title {
  margin: 0;
  font-size: 20px;
  color: #001f5a;
}

.captcha-modal-close {
  background: none;
  border: none;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  color: #001f5a;
  padding: 0 5px;
}
</style>
